import {Attribute} from "./Attribute";
import {Pages} from "./Pages";

export class AttributeValue {
    id:number;
    value:string="";
    attribute:string=""
    pages:Pages
}